import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { sortByProductLineId } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { Cart } from 'types/cartServiceV2';
import { ProductLine, ProductType } from 'types/enrollmentService';

export interface CartItemNamesByProductLineId {
  productLineId: ProductLineId;
  portfolioNames: string[];
}

export function convertNewSaleCartIntoProductLine(cart: Cart): ProductLine[] {
  const pLines: ProductLine[] = [];
  const pLinesInCart = [...new Set(cart.cartItems.map((item) => item.productLineId))];
  pLinesInCart.forEach((lineId) =>
    pLines.push({
      id: lineId,
      productType: ProductType.NEW_SALE,
      confirmedPortfolioId: null,
      browsingCriteria: cart.lastUpdateBrowsingCriteria,
    }),
  );
  return pLines;
}

export function getCartItemNamesByProductLineId(cart: Cart): CartItemNamesByProductLineId[] {
  const portfoliosByProductLine = new Map<ProductLineId, Set<string>>();

  cart.cartItems.forEach(({ productLineId, portfolioName }) => {
    const portfolioNames = portfoliosByProductLine.get(productLineId) ?? new Set<string>();
    portfolioNames.add(portfolioName);
    portfoliosByProductLine.set(productLineId, portfolioNames);
  });

  return [...portfoliosByProductLine.entries()]
    .sort(([productLineA], [productLineB]) => sortByProductLineId(productLineA, productLineB))
    .map(([productLineId, portfolioNames]) => ({
      productLineId,
      portfolioNames: [...portfolioNames],
    }));
}
